<template>
  <div>
    <h1>待办事务</h1>
  </div>
</template>

<script>
  export default {
     name: 'Wait_Deal',
     data () {
       return {
        
       }
     },
     methods: {
  
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Wait/Wait_Deal.vue